<template>
    <div>
        <el-dialog title="导出" :close-on-click-modal="false"  :visible.sync="show" class="dialog_del" :before-close="cancle">
            <p>请选择导出的选项</p>
            <el-radio v-model="exportWay" label="1">勾选项</el-radio>
            <el-radio v-model="exportWay" label="0">当前页</el-radio>
            <el-radio v-model="exportWay" label="2">全部查询结果</el-radio>

            <span slot="footer" class="dialog-footer">
            <el-button type="search" @click="submitForm" class="export_btn">导出</el-button>
            <el-button @click="cancle">取消</el-button>
            </span>
        </el-dialog>
 
    </div>
</template>

<script>
// import { Exports } from '@/api/manageConfig'
import { setSearchParams,setUrlApi } from '@/utils/index.js'
import qs from 'qs'
export default {
  props: {
    show: Boolean,
    closeDialog:Function,
    idList: Array
  },
  created(){
      
  },
  data() {
    return {
      exportWay: "1"
    }
  },
  methods: {
    cancle() {
      this.$emit('closeDialog')
      this.exportWay = "1"
    },
    submitForm(){
      let params = {}
      if(this.exportWay == 0){// 当前页
        // let _fillter = {'ids': this.$parent.curIdList}
        // let _op = {'ids': '='}
        // params = {
        //     filter : JSON.stringify(_fillter),
        //     op : JSON.stringify(_op) 
        // }
        params.ids = JSON.stringify(this.$parent.curIdList)
      } else if(this.exportWay == 1){ // 勾选项
        let curList = this.$parent.curList
        if(curList.length == 0){
          this.$message.error({message: '导出条数不能为0条'})
          return;
        }else{
            // let _fillter = {'ids': this.$parent.curList}
            // let _op = {'ids': '='}
            // params = {
            //     filter : JSON.stringify(_fillter),
            //     op : JSON.stringify(_op) 
            // }
            params.ids = JSON.stringify(this.$parent.curList)
        }
      } else if(this.exportWay == 2) { // 全部查询结果
        params = setSearchParams(this.$parent.searchForm, this.$parent.page_size, this.$parent.current_page)
        params.ids = []
      }
      let str = qs.stringify(params)
    //   console.log(str, params);
      window.open(setUrlApi() + '/index.php/api/config_management/default_show/export?' + str)
    //   this.exportData(params)
    },
    exportData(params){
      Exports(params).then(res=>{
        if(res.state == 1){
          window.open(res.data)
          this.cancle()
        }
      })
    }
  }
}
</script>

<style lang="scss">
// 弹框
.el-dialog__wrapper{
  display: flex;
  align-items: center;
  justify-content: center;

  >.el-dialog{
    border-radius: 16px;
    margin: 0 !important;
    .el-select{
      width: 100%;
    }
    .el-dialog__header{
      border-bottom: 1px solid #EBEAEA;
      height: 54px;
      color: #3135D7;
      font-size: 14px;
      padding: 16px 24px;
      .el-dialog__title{
        font-size: 14px;
        color: #3135D7;
      }
      .el-dialog__headerbtn{
        color: #CCCCCC;
        &:hover{
          color: #3135D7;
          .el-dialog__close{
            color: #3135D7;
          }
        }
      }
    }
    .el-dialog__footer{
      text-align: center;
      border-top: 1px solid #EBEAEA;
      height: 64px;
      line-height: 64px;
      padding: 0;
      .el-button--default{
        margin-left: 32px;
      }
    }
    .el-dialog__body{
      padding: 24px 48px;
      height: calc(100% - 120px);
      .el-form{
        // padding-right: 75px;
        .el-form-item__label::before{
          display: none;
        }
      }
    }
  }
}

.el-dialog__wrapper.dialog_del{
  .el-dialog{
    height: 22.9%;
    width: 23.78% !important;
    min-width: 410px;
    min-height: 214px;
  }
  .el-dialog__body{
    padding: 16px 24px ;
    color: #3135D7;
  }
}
.dialog_del{
  .el-radio{
    color: #666666;
    margin-top: 19px;
  }
  .el-radio__inner{
    width: 16px;
    height: 16px;
  }
  
}

</style>